import useProtoMethod from "./useProtoMethod";
import {
  DeleteResourceSectionRequest,
  DeleteResourceSectionResponse,
  GetResourcePageRequest,
  GetResourcePageResponse,
  ListResourceSectionsRequest,
  ListResourceSectionsResponse,
  SetResourcePlacementsRequest,
  SetResourcePlacementsResponse,
  UpsertResourceSectionRequest,
  UpsertResourceSectionResponse,
} from "protogen/resources_service_pb";

export const useListResourceSections = (
  callback?: (r: ListResourceSectionsResponse) => void,
) => {
  return useProtoMethod<
    ListResourceSectionsRequest,
    ListResourceSectionsResponse
  >("ListResourceSections", ListResourceSectionsResponse, { callback });
};

export const useUpsertResourceSection = (
  callback?: (r: UpsertResourceSectionResponse) => void,
) => {
  return useProtoMethod<
    UpsertResourceSectionRequest,
    UpsertResourceSectionResponse
  >("UpsertResourceSection", UpsertResourceSectionResponse, { callback });
};

export const useDeleteResourceSection = (
  callback?: (r: DeleteResourceSectionResponse) => void,
) => {
  return useProtoMethod<
    DeleteResourceSectionRequest,
    DeleteResourceSectionResponse
  >("DeleteResourceSection", DeleteResourceSectionResponse, { callback });
};

export const useGetResourcePage = (
  callback?: (r: GetResourcePageResponse) => void,
) => {
  return useProtoMethod<GetResourcePageRequest, GetResourcePageResponse>(
    "GetResourcePage",
    GetResourcePageResponse,
    { callback },
  );
};

export const useSetResourcePlacements = (
  callback?: (r: SetResourcePlacementsResponse) => void,
) => {
  return useProtoMethod<
    SetResourcePlacementsRequest,
    SetResourcePlacementsResponse
  >("SetResourcePlacements", SetResourcePlacementsResponse, { callback });
};
